import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLHRElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLHRElement
 */
export default class HTMLHRElement extends HTMLElement {}
